import React from 'react';
import { approvedAmountTypes, LoanStatusType } from '@apply/constants';
import { Column } from 'devextreme-react/data-grid';
import { formatCurrency } from '../../common/SharedFunctions';

interface LoanPropertyCommitOrApprovalColumnParameters {
    statusId: LoanStatusType;
}

export const LoanPropertyCommitOrApprovalColumn: React.FC<LoanPropertyCommitOrApprovalColumnParameters> = ({ statusId }) => {
    const onCommittedRender = (e) => {
        const committedAmt = e.data.commitment + e.data.originationFee;
        if (!committedAmt) {
            return null;
        }
        return formatCurrency(committedAmt, 0);
    };

    if (approvedAmountTypes.includes(statusId)) {
        return [
            <Column
                key='committed'
                dataField='commitment'
                caption='Approved Amt'
                dataType='number'
                format='currency'
                width={110}
                alignment={'left'}
            />,
        ];
    } else {
        return [
            <Column
                key='committed'
                caption='Committed'
                dataType='number'
                format='currency'
                cellRender={onCommittedRender}
                width={90}
                alignment={'left'}
            />,
        ];
    }
};
